import { Typography } from "@mui/material";
import SinglePredictionInterval from "./SinglePredictionInterval";
import { getFilteredIntervals } from "../prediction.util";

const PredictionInterval = ({ intervals, filter, user }) => {

    const { predictionType, month, day } = filter;

    const { birthDetails } = user;

    const filteredIntervals = getFilteredIntervals(intervals, ({ predictionType, birthDate: birthDetails.date, birthTimezone: birthDetails.timezone, userCurrentTimezone: user.userCurrentTimezone, targetMonth: month, targetDay: day }));

    if (!filteredIntervals?.intervals?.length) return null;

    return (
        <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "8px"
            }}
        >
            {filteredIntervals.intervals.map((interval, index) => (
                <div
                    key={index}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "8px"
                    }}
                >
                    <SinglePredictionInterval
                        interval={interval}
                        timezone={user.userCurrentTimezone}
                        predictionType={predictionType}
                    />

                    {index < filteredIntervals.intervals.length - 1 && (
                        <Typography
                            variant="caption"
                            color="primary.main"
                            sx={{
                                display: "block",
                                mb: 1,
                                fontSize: "0.875rem",
                                fontWeight: "medium",
                            }}>||</Typography>
                    )}
                </div>
            ))}
        </div>
    );
};

export default PredictionInterval;
